import React, { createContext, useState, useEffect, useCallback } from 'react';
import { withApollo } from 'react-apollo';
import storage from '@fci/business-layer/storage';
import { token } from '@fci/business-layer/constants';
import { GetCurrentUserDetail } from '@fci/business-layer/services/user';

export const UserContext = createContext({
    user: null,
    loading: true,
    refetchUser: () => {}
});

const UserProviderComponent = ({ client, children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUser = useCallback(async () => {
        const authToken = storage.getItem(token);
        if (!authToken) {
            setUser(null);
            setLoading(false);
            return;
        }

        try {
            const res = await client.query({
                query: GetCurrentUserDetail,
                fetchPolicy: 'cache-first'
            });
            if (res?.data?.user) {
                setUser(res.data.user);
            }
        } catch (err) {
            console.error('Error fetching user detail in UserProvider:', err);
        } finally {
            setLoading(false);
        }
    }, [client]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return (
        <UserContext.Provider value={{ user, loading, refetchUser: fetchUser }}>
            {children}
        </UserContext.Provider>
    );
};

export const UserProvider = withApollo(UserProviderComponent);
